var map = {
	"./alert.svg": 77301,
	"./availability.svg": 83395,
	"./bed.svg": 97681,
	"./bedding-and-linen.svg": 66987,
	"./chevron-left.svg": 54514,
	"./chevron-right.svg": 516,
	"./closet.svg": 45138,
	"./desk-and-chair.svg": 49044,
	"./details.svg": 32538,
	"./hair-dryer.svg": 76268,
	"./info.svg": 74698,
	"./locker.svg": 86963,
	"./mini-fridge.svg": 82314,
	"./person.svg": 2187,
	"./pika.svg": 65736,
	"./pin.svg": 46897,
	"./popup.svg": 35592,
	"./progress_bar/booking_details.svg": 57986,
	"./progress_bar/complete.svg": 9195,
	"./progress_bar/finished.svg": 40602,
	"./progress_bar/location.svg": 23551,
	"./progress_bar/payment.svg": 58508,
	"./progress_bar/personal_details.svg": 89581,
	"./progress_bar/room_type.svg": 11371,
	"./progress_bar/summary.svg": 43821,
	"./restroom.svg": 45088,
	"./separator.svg": 95724,
	"./shower.svg": 60304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;